<section class="section-welcome">
  <div class="container">
    <a class="back-link" routerLink="/entenda-as-finalidades-de-uso"
      ><img src="assets/round-arrow-back.svg" alt="Icone (voltar)" /> Voltar</a
    >
    <div class="content">
      <div class="content-left">
        <h1>Para o direcionamento de ofertas</h1>
        <p>
          O uso de dados pessoais para segmentar audiências e analisar o
          potencial de mercado permite o direcionamento de ofertas mais
          adequadas ao perfil dos titulares, com a apresentação de soluções e
          comunicações mais aderente aos seus interesses e às suas necessidades.
        </p>
        <h2>
          Benefícios para você com o uso de seus<br />
          dados pessoais em soluções de marketing
        </h2>
        <div class="white-text">
          <p>
            O uso consciente dos seus dados pessoais em soluções de marketing
            pode trazer inúmeros benefícios para você. Veja alguns deles:
          </p>
          <ul>
            <li>
              Ao te conhecer melhor, nossos clientes podem te beneficiar com:
            </li>

            <li class="inside">
              Ofertas de produtos e serviços mais aderentes e relevantes ao seu
              perfil;
            </li>
            <li class="inside">Comunicações e promoções exclusivas;</li>
            <li class="inside">Conteúdos relevantes;</li>
            <li class="inside">
              Melhor experiência em websites e aplicativos;
            </li>

            <li>
              Comunicações personalizadas com o seu nome e outras informações
              pessoais tornam a mensagem mais alinhada aos seus interesses,
              necessidades e preferências individuais, proporcionando a você um
              contato mais próximo e humanizado, além de uma melhor experiência;
            </li>
            <li>
              O tratamento adequado dos seus dados pessoais proporciona maior
              segurança e fortalece os compromissos da Serasa com a legislação
              aplicável.
            </li>
          </ul>
        </div>
      </div>
      <div class="content-right">
        <img
          src="assets/illustration-pc-2.svg"
          alt="Ilustração (Computador e dados)"
        />
      </div>
    </div>
  </div>
</section>

<section class="secondary-section">
  <div class="container">
    <h3>O uso dos seus dados pessoais em nossas soluções de marketing</h3>
    <p class="text-description" style="text-indent: 2.5em">
      Nós combinamos os seus dados pessoais com inteligência analítica para
      apoiar os nossos clientes no desenvolvimento de comunicações relevantes e
      na execução de estratégias que visam superar desafios de negócio, garantir
      mensagens personalizadas e beneficiar os titulares dos dados com ofertas
      aderentes e alinhadas aos seus interesses, necessidades e preferências.
    </p>

    <p class="text-description" style="text-indent: 2em">
      O <strong>uso consciente de dados pessoais</strong> em nossos produtos e
      serviços de marketing é essencial para segmentar audiências e proporcionar
      uma melhor análise de interesses e de potencial de mercado para, assim, os
      clientes serem mais precisos no direcionamento de ofertas e soluções que
      atendam, por exemplo, aos seguintes objetivos
    </p>

    <ul>
      <li>
        <img src="assets/icon-search-pink.svg" alt="ícone lupa" />
        <p>
          Melhor entendimento dos interesses, necessidades e preferências dos
          titulares, para gerar ações mais eficientes e personalizadas
        </p>
      </li>
      <li>
        <img src="assets/icon-light-pink.svg" alt="ícone lâmpada" />
        <p>
          Garantia de novas ideias para criação de estratégias e identificação
          de novos clientes
        </p>
      </li>
      <li>
        <img src="assets/icon-share-pink.svg" alt="ícone compartilhar" />
        <p>
          Aprimoramento de oportunidades de expansão e retração de mercado com
          base em dados pessoais confiáveis
        </p>
      </li>
    </ul>

    <p class="text-description">
      Você pode solicitar a interrupção (“opt-out”) ou a retomada do tratamento
      de seus dados pessoais em soluções de
      <br />
      <a class="text-description-link" routerLink="/gerenciar-preferencias">
        direcionamento de ofertas.
      </a>
    </p>
  </div>
</section>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>
